import React, { useRef } from 'react';
import { Button, Box } from '@mui/material';
import { uploadImages } from '../services/api';
import { CloudUpload } from '@mui/icons-material';

function ImageUploader({ onUpload }) {
  const fileInputRef = useRef();

  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      try {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          formData.append('images', files[i]);
        }
        await uploadImages(formData);
        onUpload(files);
      } catch (error) {
        console.error('Error uploading files:', error);
      }
    }
  };

  return (
    <Box sx={{ my: 2 }}>
      <input
        type="file"
        multiple
        accept="image/*"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <Button
        variant="contained"
        color="secondary"
        startIcon={<CloudUpload />}
        onClick={() => fileInputRef.current.click()}
      >
        上传图片
      </Button>
    </Box>
  );
}

export default ImageUploader;
